import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { movieTypePluralTitlesHash } from '@culture/utils/helpers/movies';

import BroadcastCard from 'components/cards/BroadcastCard';
import SectionLayout from 'components/SectionLayout';
import SlideSection from 'components/SlideSection';

import CommonPropTypes from 'utils/propTypes/common';

const MoviesByTypes = ({ movies }) => {
	const titlesHash = { ...movieTypePluralTitlesHash, broadcast: 'Другие' };

	const blocks = Object.keys(movies).reduce((memo, key) => {
		if (!_.isEmpty(movies[key])) {
			const description = titlesHash[key];

			memo.push(
				<SlideSection
					key={key}
					title={description}
					moreControl={{
						title: `Все ${description.toLowerCase()}`,
						url: `/national-streaming/archive/type-${key}`
					}}
					items={movies[key]}
				>
					{_(movies[key]).map((entity) => (
						<BroadcastCard key={entity._id} data={entity} />
					))}
				</SlideSection>
			);
		}

		return memo;
	}, []);

	return !_.isEmpty(blocks) ? <SectionLayout>{blocks}</SectionLayout> : null;
};

MoviesByTypes.propTypes = {
	movies: PropTypes.objectOf(CommonPropTypes.entities).isRequired
};

export default MoviesByTypes;
